import storage from 'proxy-storage';
import usAreaCodes, { tollFreeCodes } from '../../helpers/us-area-codes';

/**
 * @private
 */
const US_PHONE = /1?\W*([2-9][0-8][0-9])\W*([0-9][0-9]{2})\W*([0-9]{4})(\se?x?t?(\d*))?/;

/**
 * @public
 * Evaluates if the value is a valid US phone number.
 *
 * @param  {Object} obj: an object with the properties {field, value, message}
 *         The field to validate, its current value and an error message.
 * @return {Object} An object indicating if the the field is valid or not.
 */
export default function phone({field, value, message, enable800}) {
  const areaCode = +value.replace(/\D/g, '').substring(0, 3);
  const result = {field, isValid: true};
  const areaCodes = usAreaCodes.slice(0);

  const invalidPhonesOnDemand =
    storage.getItem('hc').invalidPhonesOnDemand || [];
  const isValid = invalidPhonesOnDemand.indexOf(value) < 0;

  if (enable800 === true) {
    areaCodes.push(...tollFreeCodes);
  }

  if (areaCodes.indexOf(areaCode) < 0 || !US_PHONE.test(value) || !isValid) {
    result.message = message;
    result.isValid = false;
    return result;
  }
  return result;
}
